<i18n>
{
  "en": {
    "appName": " Verification System",
    "messages": {
      "welcome": "Welcome to Verification System !",
      "thanks": "Thank you for your cooperation in our final decision procedure.",
      "inHere": "You will ..",
      "submitOriginal": "- Submit person confirmation data of your work",
      "submitHiRes": "- Submit high resolution data of your work",
      "submitInfo": "- Enter additional questions",
      "helpOrignal": "Please submit \"RAW data\" of the winning candidate work or “original data before processing (the highest quality of JPEG data or TIFF data with EXIF information left). <br> ※ For the prevention of plagiarism We sent you for the purpose of verifying your identity.",
      "helpHiRes": "Please submit \"High Resolution Image Data\" (JPEG or TIFF data with the highest quality) without credit for the winning candidate. <br> ※ We have you send for introductions on this photo contest result announcement page and related sites.",
      "willDo": "in this system. Please use the form below.",
      "howto": "※ The operation can be performed sequentially for each step <br> ※ After receiving each data submission, we will confirm at the secretariat <br> ※ We will notify you by e-mail when the confirmation by the secretariat is over or the status is changed <br> ※ When entering comments, please do not use abbreviations, such as initial letters only. (e.g., names of products, services, facilities, or other proper nouns) <br> ※ Please do not cite the names of organizations or works that are not related to this contest or its affiliated companies, works, etc.",
      "subjectRules": "Please be aware that if any of the winning or candidate works violates the rules of the application guidelines including the following, we may cancel the winning of the contest.",
      "subjectRulesDetails": "",
      "needAction": "There are {count} candidates.",
      "howToClick": "The following works are candidates for the award. Click on the image below to see details of the winners",
      "pleaseOriginalSubmit": "There is {count} unsubmitted identity verification data",
      "pleaseHiResSubmit": "There is {count} unsubmitted high resolution data count",
      "pleaseInfoSubmit": "There is {count} unsubmitted addtional information count",
      "howToProceed": "",
      "uploadNotice": "The procedure has not been completed. Please register {dataType}.",
      "uploadNoticeConjunction": " and ",
      "uploadNoticeHiResData": "High Resolution Image Data",
      "uploadNoticeIdentityVerificationData": "identity verification Image data",
      "plsChangePassword": "Please change the password on the password change screen from the viewpoint of account protection."
    },
    "label": {
      "notice": "Information",
      "plsChangePassword": "Please change your password.",
      "ok": "OK"
    }
  },
  "ja": {
    "appName": "手続きシステム",
    "messages": {
      "welcome": "手続きシステムへようこそ！",
      "thanks": "この度は弊社の受賞確定手続きにご協力いただきありがとうございます。",
      "inHere": "こちらの手続きシステムでは、",
      "submitOriginal": "・ご本人様確認作業",
      "submitHiRes": "・高解像度データ提出",
      "submitInfo": "・追加情報の入力",
      "helpOrignal": "受賞候補作品の「RAWデータ」もしくは「Exif（撮影日時や撮影機種）が保存されている、加工前のオリジナルデータ（カメラで撮ったままの、何のソフトウェアも使用していない画像データ）」をご提出下さい。<br>※盗作防止のためにご本人様確認を行う目的でお願いさせていただいています。恐れ入りますがご協力をお願い申し上げます。",
      "helpHiRes": "受賞候補作品のクレジットなしの「高解像度画像データ」（JPEGもしくはTIFFデータで最高画質のもの）をご提出下さい。<br>※当フォトコンテスト結果発表ページや関連サイト等でのご紹介などのためにお願いさせていただいております。",
      "willDo": "を実施していただきます。下記のフォームより実施をお願い致します。",
      "howto": "※操作は各ステップごとに順次実施可能になります<br>※各データ提出を頂いたあとは、事務局で確認をさせていただきます<br>※事務局による確認終了や、ステータスの変更時にはメールでお知らせ致します<br>※本ページの第三者への開示はお控えください<br>※作品コメントをご入力いただく場合、頭文字のアルファベットのみなど略称を記載することは避けていただきますようお願いいたします。（例：商品名やサービス名、施設名等の固有名詞など）<br>※本コンテストやその関係会社・作品等と関係のない団体・作品の名称などを引用することはお避けください。",
      "subjectRules": "※受賞作品または受賞候補作品で以下を含む応募要項の規約に違反があった場合、コンテストの受賞を取り消しとさせていただくことがありますので、ご注意ください。",
      "subjectRulesDetails": "・応募作品に使用される著作物、肖像については、応募者本人が著作権・肖像権等一切の権利を有するもの、または権利者から事前に使用承諾を得たものとします。被写体に人物が含まれている場合は、事前にその方の承諾を得るなど、肖像権の侵害等が生じないように応募者本人の責任においてご確認ください。<br>・被写体が未成年の場合は、その保護者の許可も得たものに限ります。<br>・神社・仏閣、商業施設などが写り込んでいる場合も、撮影・応募許諾を得たうえでご応募ください。<br>・被写体に看板・ネオンサイン・ブランドロゴ等が含まれる場合や公序良俗に反すると判断される作品のご応募はご遠慮ください。<br>・住所情報が写り込んでいる作品のご応募もご遠慮ください。",
      "needAction": "入選候補作品は {count} つです",
      "howToClick": "下記の作品が受賞候補です。下記の画像をクリックすると受賞候補作品の詳細が見れます",
      "pleaseOriginalSubmit": "未提出の本人確認データが {count} 件あります",
      "pleaseHiResSubmit": "未提出の高解像度データが {count} 件あります",
      "pleaseInfoSubmit": "未提出の追加情報が {count} 件あります",
      "howToProceed": "",
      "uploadNotice": "手続きが完了していません。{dataType}を登録してください。",
      "uploadNoticeConjunction": "および、",
      "uploadNoticeHiResData": "高解像度データ",
      "uploadNoticeIdentityVerificationData": "本人確認データ",
      "plsChangePassword": "デフォルトのパスワードが設定されたままのため、パスワード変更画面にてパスワードを変更してください。"
    },
    "label": {
      "notice": "お知らせ",
      "plsChangePassword": "パスワードを変更して下さい",
      "ok": "OK"
    }
  }
}
</i18n>

<template>
  <div>
    <Toolbar :title="title"></Toolbar>
    <v-layout>
      <!-- <v-flex md2 lg2>
        <Navbar />
      </v-flex> -->

      <v-flex md12 lg12>
        <v-container :class="responsiveContainer">
          <v-layout row wrap justify-center>
            <v-flex xs12 sm12 md12 lg12> </v-flex>

            <v-flex xs12 sm12 md12 lg12 v-if="!this.user.checkListStatus">
              <br />
              <br />
              <v-layout justify-center>
                <v-progress-circular
                  indeterminate
                  :size="50"
                ></v-progress-circular>
              </v-layout>
            </v-flex>
            <CheckListForm :user="user" v-if="this.user.checkListStatus && !isCheckListCompleted()" :done="checkListDone" />
            <v-flex xs12 sm12 md12 lg12 v-if="this.user.checkListStatus && isCheckListCompleted()">
              <br />
              <br />
              <div style="text-align: right;">
                <v-btn outline color="primary" @click="topHelp = !topHelp"
                  >{{ $t('label.notice')
                  }}<v-icon small right>{{
                    topHelp ? 'clear' : 'menu'
                  }}</v-icon></v-btn
                >
              </div>
              <Infobox
                v-show="topHelp"
                :title="$t('messages.welcome')"
              >
                <p class="subheading">{{ $t('messages.thanks') }}</p>
                <span class="ml-3">{{ $t('messages.inHere') }}</span>
                <div class="info-text">
                  <b>{{ $t('messages.submitOriginal') }}</b>
                  <a :href="'/cp/' + getCampaignCode() + '/me/help#category2'" target="_blank" style="text-decoration: none;">
                    <v-icon
                      class="ml-1 hover-icon"
                      slot="activator"
                      dark
                      color="primary"
                      >help_outline</v-icon
                    >
                  </a>
                </div>

                <div class="info-text" v-if="campaign && campaign.requireHiRes">
                  <b>{{ $t('messages.submitHiRes') }}</b>
                  <a :href="'/cp/' + getCampaignCode() + '/me/help#category3'" target="_blank" style="text-decoration: none;">
                    <v-icon
                      class="ml-1 hover-icon"
                      slot="activator"
                      dark
                      color="primary"
                      >help_outline</v-icon
                    >
                  </a>
                </div>
                <div class="info-text">
                  <b>{{ $t('messages.submitInfo') }}</b>
                  <a :href="'/cp/' + getCampaignCode() + '/me/help#category4'" target="_blank" style="text-decoration: none;">
                    <v-icon
                            class="ml-1 hover-icon"
                            slot="activator"
                            dark
                            color="primary"
                    >help_outline</v-icon
                    >
                  </a>
                </div>
                <div class="ml-3 mb-3">
                  <span>{{ $t('messages.willDo') }}</span>
                  <br /><br />
                  <div v-html="$t('messages.howto')"></div>
                  <div class="mt-0 red--text" v-html="$t('messages.subjectRules')"></div>
                  <div class="ml-2 red--text" v-html="$t('messages.subjectRulesDetails')"></div>
                </div>
              </Infobox>

              <Infobox
                v-show="topHelp"
                v-if="needNotice"
                :title="$t('label.notice')"
              >
                <div
                  v-if="this.metrics.notSubmittedOriginalCount > 0 || this.metrics.notSubmittedHiResCount > 0"
                  ref="uploadNotice"
                  class="uploadNotice info-text"
                >
                  <span
                    :class="[ 'red--text font-weight-bold',
                      this.isTopNoticeAnimationStart ? 'animationStart' : '',
                      this.isTopNoticeAnimationEnd ? 'animationEnd' : '',
                    ]"
                  >
                    {{
                      $t('messages.uploadNotice', {
                        dataType:
                          (this.metrics.notSubmittedOriginalCount > 0 ? $t('messages.uploadNoticeIdentityVerificationData') : '') +
                          ((this.metrics.notSubmittedOriginalCount > 0 && this.metrics.notSubmittedHiResCount > 0) ? $t('messages.uploadNoticeConjunction') : '') +
                          (this.metrics.notSubmittedHiResCount > 0 ? $t('messages.uploadNoticeHiResData') : '')
                      })
                    }}
                  </span>
                </div>
                <div
                  v-if="metrics.notSubmittedOriginalCount > 0"
                  class="info-text"
                >
                  <span class="red--text font-weight-bold">
                    {{
                      $t('messages.pleaseOriginalSubmit', {
                        count: metrics.notSubmittedOriginalCount
                      })
                    }}
                  </span>
                </div>
                <div
                  v-if="metrics.notSubmittedHiResCount > 0"
                  class="info-text"
                >
                  <span class="red--text font-weight-bold">
                    {{
                      $t('messages.pleaseHiResSubmit', {
                        count: metrics.notSubmittedHiResCount
                      })
                    }}
                  </span>
                </div>
                <div
                  v-if="metrics.notSubmittedAddInformationCount > 0"
                  class="info-text"
                >
                  <span class="red--text font-weight-bold">
                    {{
                      $t('messages.pleaseInfoSubmit', {
                        count: metrics.notSubmittedAddInformationCount
                      })
                    }}
                  </span>
                </div>

                <div class="info-text" v-if="works.length > 1">
                  <v-icon color="black">info</v-icon>
                  {{ $t('messages.needAction', { count: works.length }) }}
                </div>
                <div class="info-text" v-if="works.length > 1">
                  <v-icon color="black">info</v-icon>
                  {{ $t('messages.howToClick') }}
                </div>
              </Infobox>
              <!-- <v-alert v-if="works.length > 1" :value="true" color="info">
                <p class="title">
                  {{ $t('messages.needAction', { count: works.length }) }}
                </p>
                <p class="subheading" v-if="works.length > 1">
                  <v-icon dark>help_outline</v-icon
                  >{{ $t('messages.howToClick') }}
                </p>
              </v-alert> -->
              <v-flex sm12 md12 lg12 v-if="works.length > 1">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex
                      xs4
                      sm3
                      md3
                      lg2
                      xl2
                      v-for="(work, index) in works"
                      :key="index"
                      :class="[
                        isSelectedWork(index) ? 'selected' : '',
                        'main-card'
                      ]"
                    >
                      <v-card
                        min-height="100%"
                        min-width="100%"
                        hover
                        raised
                        light
                        class="image-card"
                        @click="nextTab(index)"
                      >
                        <v-img
                          :aspect-ratio="16 / 9"
                          :src="work.thumbnailMediaUrl"
                        ></v-img>

                        <v-card-text>
                          <span class="card-status-text">
                            {{ getEnumStr('workStatus', work.status) }}
                          </span>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>

              <br />

              <v-tabs
                height="0"
                v-model="active"
                slider-color="primary"
                hide-slider
                class="main-tab"
                fixed-tabs
              >
                <v-tab v-for="work in works" :key="work.id"></v-tab>
                <v-tabs-items touchless>
                  <v-tab-item v-for="work in works" :key="work.id">
                    <StepContent :work="work"></StepContent>
                  </v-tab-item>
                </v-tabs-items>
              </v-tabs>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>

    <InstagramAuthenticatedDialog
      @click="closeInstagramDialog"
      :dialog="isOpenIgDialog"
    ></InstagramAuthenticatedDialog>

    <TwitterAuthenticatedDialog
      @click="closeTwitterDialog"
      :dialog="isOpenTwDialog"
    ></TwitterAuthenticatedDialog>

    <v-dialog v-model="campaignDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">{{
          $t('label.plsChangePassword')
        }}</v-card-title>
        <v-card-text>{{ $t('messages.plsChangePassword') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click="induceToChangePassword">{{
            $t('label.ok')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Toolbar from '@/components/molecules/Toolbar.vue';
import InstagramAuthenticatedDialog from '@/components/dialogs/InstagramAuthenticatedDialog.vue';
import TwitterAuthenticatedDialog from '@/components/dialogs/TwitterAuthenticatedDialog.vue';
import StepContent from '@/components/molecules/StepContent.vue';
import CheckListForm from '@/components/molecules/CheckListForm.vue';
import Infobox from '@/components/atoms/Infobox.vue';
import { mapGetters } from 'vuex';
import { Me } from '@/api';
import { EnumSourceTypes } from '@/enum/enum.js';
import TokenManager from '@/utils/TokenManager';
import StorageManager from '@/utils/StorageManager';

export default {
  components: {
    Toolbar,
    InstagramAuthenticatedDialog,
    TwitterAuthenticatedDialog,
    StepContent,
    Infobox,
    CheckListForm
  },
  methods: {
    scrollHandler() {
      const rect = this.$refs.uploadNotice.getBoundingClientRect();
      if (rect.y >= 0 && rect.y <= window.innerHeight) {
        if (!this.isTopNoticeAnimationStart && !this.isTopNoticeAnimationEnd) {
          this.isTopNoticeAnimationStart = true;
          setTimeout(() => {
            this.isTopNoticeAnimationEnd = true;
          }, 500);
        }
      } else {
        this.isTopNoticeAnimationStart = false;
        this.isTopNoticeAnimationEnd = false;
      }
    },
    isCheckListCompleted() {
      // checkListStatusの状態によって、事前確認事項が完了したかどうかを反映
      // 1, 4以外は完了していないと判定する
      // 1.回答不要 2.未回答→事前確認画面表 3.回答不備→事前確認画面表 4.回答済み
      if (this.user && this.user.checkListStatus && this.user.checkListStatus != 2 && this.user.checkListStatus != 3) {
        return true
      }
      return false
    },
    closeInstagramDialog() {
      // Instagram認証完了ダイアログを閉じる処理
      this.isOpenIgDialog = false;
      this.$nextTick(function() {
        // this.$router.push('/me'); // 通常のホームに遷移
      });
    },
    closeTwitterDialog() {
      // Twitter認証完了ダイアログを閉じる処理
      this.isOpenTwDialog = false;
      this.$nextTick(function() {
        // this.$router.push('/me'); // 通常のホームに遷移
      });
    },
    nextTab(index) {
      this.active = parseInt(index);
      this.$router.push({
        path: '/cp/' + this.getCampaignCode() + `/me/${index}`
      });
    },
    isSelectedWork(index) {
      return index === this.active;
    },
    /**
     * APIからEnumのリストを取得し保存する
     * 都度のリクエストを防いで、それなりにシンプル…だと思う…
     * TODO APIコールなのでClientに行ってもいいかも
     */
    setAllApiEnums() {
      Me.fetchAllEmum().then(data => {
        // codeをkeyとした配列に整形
        let newObj = {};
        for (let type in data) {
          newObj[type] = {};
          for (let key in data[type]) {
            newObj[type][data[type][key].code] = data[type][key];
          }
        }
        this.apiEnums = newObj;
      });
    },
    /**
     * EnumのTypeとCodeとlocaleからEnumの文字列を返却
     * @param String type EnumのType
     * @param Integer code EnumのCode
     */
    getEnumStr(type, code) {
      return this.$store.getters.getEnumByCode({ type, code });
    },
    induceToChangePassword() {
      this.campaignDialog = false;
      localStorage.isClickFirstPasswordChangeDialog = true;
      this.$router.push('/cp/' + this.$route.params.campaignCode + '/me/edit');
    },
    getCampaignCode: () => {
      return StorageManager.getItem('CAMPAIGN_CODE_SESSION_KEY');
    },
    checkListDone() {
      // チェックリスト登録が完了した場合、データを再読み込みする
      this.fetchUserData();
    },
    fetchUserData() {
      Me.fetchDataAtOnce().then(data => {
        this.$store.dispatch('setCurrentCampaign', data.campaign);
        this.user = data.me;
        this.metrics = data.me.metrics;
        this.works = data.me.works;
        if (
          data.me.signInCount === 1 &&
          data.me.sourceType === EnumSourceTypes.CampaignSystem &&
          localStorage.isClickFirstPasswordChangeDialog !== 'true'
        ) {
          this.campaignDialog = true;
        }
      });
    }
  },
  data() {
    return {
      topHelp: true,
      user: {},
      active: null, //現在選択されているworksの配列の番号
      isOpenIgDialog: false,
      isOpenTwDialog: false,
      campaignDialog: false,
      works: {},
      metrics: {},
      color: {
        step: {
          now: '#55355e',
          complete: 'green'
        }
      },
      apiEnums: {},
      isTopNoticeAnimationStart: false,
      isTopNoticeAnimationEnd: false
    };
  },
  computed: {
    ...mapGetters({ campaign: 'getCurrentCampaign' }),
    title: function() {
      return this.campaign.name + this.$t('appName');
    },
    responsiveContainer: function() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return 'pl-2 pr-2';
      }
      return '';
    },
    needNotice: function() {
      return (
        this.metrics.notSubmittedOriginalCount > 0 ||
        this.metrics.notSubmittedHiResCount > 0 ||
        this.metrics.notSubmittedAddInformationCount > 0 ||
        this.works.length > 1
      );
    }
  },
  beforeMount: function() {
    //初期状態で表示するタブをURLパラメータから取得・設定する
    this.active = parseInt(this.$route.params.tabIndex || 0);
  },
  mounted: function() {
    //Instagramからの遷移の場合は、最初にダイアログを表示する
    if (sessionStorage.getItem('isRedirectFromIg') === 'true') {
      this.isOpenIgDialog = true;
      sessionStorage.setItem('isRedirectFromIg', 'false');
    }
    //Twitterからの遷移の場合は、最初にダイアログを表示する
    if (sessionStorage.getItem('isRedirectFromTw') === 'true') {
      this.isOpenTwDialog = true;
      sessionStorage.setItem('isRedirectFromTw', 'false');
    }

    if (
      !StorageManager.getItem('CAMPAIGN_CODE_SESSION_KEY') &&
      this.$route.params.campaignCode !==
        StorageManager.getItem('CAMPAIGN_CODE_SESSION_KEY')
    ) {
      TokenManager.remove();
      this.$router.push('/cp/' + this.$route.params.campaignCode + '/login');
    }

    // メインのデータフェッチ処理
    this.fetchUserData()

    // スクロールのハンドリング
    window.addEventListener("scroll", this.scrollHandler);

    this.$store.dispatch('fetchApiEnums');
  }
};
</script>

<style scoped>
div.info-text {
  margin: 10px;
  font-size: 1.1em;
}
span.card-status-text {
  font-weight: bold;
  color: #F87060;
}
span.bold {
  font-weight: bold;
}
.btn-icon {
  margin-right: 3px;
}
div.main-card .v-card {
  border-radius: 5px;
}
div.main-card {
  opacity: 0.5;
}
div.main-card:hover {
  opacity: 0.8;
}
div.selected.main-card {
  /* background: linear-gradient(-45deg, #FFD166, #06D6A0)  !important; */
  background: linear-gradient(-45deg, #F87060, #272059, #55355e)  !important;
  opacity: 1;
  border-radius: 7px;
}
.v-stepper {
  border-radius: 7px;
}
div.main-tab {
  border-radius: 7px 7px 0 0;
}
div:has(> div.v-tabs__div) {
  display: none;
}
.hover-icon {
  cursor: pointer;
}
.hover-icon:hover {
  opacity: 0.5;
}
.uploadNotice span {
  transition: all 0.5s;
}
.uploadNotice span.animationStart {
  background-color: #ff7070;
}
.uploadNotice span.animationEnd {
  background-color: unset;
}
</style>
